import React from "react";

import { CpvCode } from "../RecordLandingPage";

import css from "./CpvCodes.module.scss";

type Props = {
  items: CpvCode[];
};

export default function CpvCodes({ items }: Props) {
  const uniqueItems = Array.from(new Map(items.map((item) => [item.code, item])).values());

  return (
    <div className={css.container}>
      {uniqueItems.map((item) =>
        item.href ? (
          <a href={item.href} key={item.code} className={css.link}>
            <div className={css.item}>
              {item.code} - {item.title}
            </div>
          </a>
        ) : (
          <div key={item.code} className={css.item}>
            {item.code} - {item.title}
          </div>
        ),
      )}
    </div>
  );
}
